
// 1.-este archivo renderiza todas las preguntas

import React from 'react'
import useResponderExamen from '../../hooks/examen/useResponderExamen';
import PreguntaExamen from "../../components/PreguntaExamen";
import { Toaster } from "react-hot-toast";
import CuentaRegresivaExamen from "../../functions/CuentaRegresivaExamen";
import { Button } from "antd";


export const ResponderExamen = () => {

    const { nombreMateria, preguntasDeMateria, cuentaRegresivaTerminada, verificarTerminarExamen } = useResponderExamen();

    return (
        <>
            <h1 style={{fontSize: 30}}>{ nombreMateria }</h1>

            {
                //la cuenta regresiva debe iniciar después de haberse cargado las preguntas
                preguntasDeMateria &&
                <div className="cuentaRegresiva">
                    <CuentaRegresivaExamen
                        cuentaRegresivaTerminada={cuentaRegresivaTerminada}
                    />
                </div>
            }

            <p className='lead'>Lea las siguientes preguntas y seleccione la respuesta correcta.</p>


            { preguntasDeMateria.map( ( e, i ) => (
                <PreguntaExamen
                    key = { e.pk_preguntas }
                    imagen = { e.imagen }
                    pregunta = { e.pregunta }
                    respuestas = { e.respuestas }
                    indice={i + 1}
                    pk_pregunta = {e.pk_preguntas}
                />
            ))
            }

            <Button type="primary" onClick={() => {verificarTerminarExamen()}} >Finalizar examen</Button>

            <Toaster position='top-right'/>
        </>
    )
}
